export default __webpack_public_path__ + "static/climbing-gear-06e5be00bc477321b2af39cf59aa97f4.png";